import { render, staticRenderFns } from "./UiMessageModal.vue?vue&type=template&id=2e9a4aa6&lang=pug&"
import script from "./UiMessageModal.vue?vue&type=script&lang=js&"
export * from "./UiMessageModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports